import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardHeader, CardBody, Button, Spinner } from 'reactstrap';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('system_configuration');

interface ConfigContentCardProps {
  title: string;
  icon: string;
  loading: boolean;
  onReset: () => void;
  onSave: () => void;
  children: React.ReactNode;
}

const ConfigContentCard: React.FC<ConfigContentCardProps> = ({
  title,
  icon,
  loading,
  onReset,
  onSave,
  children,
}) => {
  const location = useLocation();

  return (
    <Card>
      <CardHeader className="d-flex align-items-center justify-content-between">
        <h5 className="card-title mb-0">
          <i className={icon + ' me-2'}></i>
          {title}
        </h5>
        <div className="d-flex gap-2">
          <Button color="light" onClick={onReset} disabled={loading}>
            <i className="ri-refresh-line me-1"></i>
            {st('reset_button')}
          </Button>
          {PageActionPermission.canDisplay(location.pathname, 'button-save') && (
          <Button
            color="success"
            data-action-code="button-save"
            data-action-name="Lưu cấu hình"
            onClick={onSave}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                {st('dang_luu_text')}
              </>
            ) : (
              <>
                <i className="ri-save-line me-1"></i>
                {st('luu_cau_hinh_text')}
              </>
            )}
          </Button>
          )}
        </div>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  );
};

export default ConfigContentCard;